import React from 'react';
import styled from 'styled-components';
import ModalCenter from '@/common/components/modal/ModalCenter';
import { LabelInput } from '@/common/components/input/LabelInput';
import { Button } from '@/common/components/button/Button';
import { semanticColors } from '@/common/styles/colorTokens';

interface TempAuthModalProps {
  isOpen: boolean;
  onClose: () => void;
  tempPhoneNumber: string;
  tempPhoneError: string;
  isUpdating: boolean;
  onPhoneNumberChange: (value: string) => void;
  onSubmit: () => void;
}

const TempAuthModal: React.FC<TempAuthModalProps> = ({
  isOpen,
  onClose,
  tempPhoneNumber,
  tempPhoneError,
  isUpdating,
  onPhoneNumberChange,
  onSubmit,
}) => {
  return (
    <ModalCenter
      isOpen={isOpen}
      onClose={onClose}
      title="본인 인증"
      maxWidth="400px"
    >
      <ModalContentContainer>
        <ModalDescription>
          비밀번호 변경을 위해 본인 인증이 필요합니다.<br/>
          등록된 핸드폰번호를 입력해주세요.
        </ModalDescription>
        
        <LabelInput
          label="핸드폰번호"
          value={tempPhoneNumber}
          onChange={(e) => onPhoneNumberChange(e.target.value)}
          placeholder="010-0000-0000"
          error={!!tempPhoneError}
          errorMessage={tempPhoneError}
          disabled={isUpdating}
        />
        
        <ModalButtonContainer>
          <Button
            $variant="outline"
            $size="md"
            onClick={onClose}
            disabled={isUpdating}
            style={{ flex: 1 }}
          >
            취소
          </Button>
          <Button
            $variant="fill"
            $size="md"
            onClick={onSubmit}
            disabled={isUpdating}
            style={{ flex: 1 }}
          >
            인증하기
          </Button>
        </ModalButtonContainer>
      </ModalContentContainer>
    </ModalCenter>
  );
};

const ModalContentContainer = styled.div`
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

const ModalButtonContainer = styled.div`
  display: flex;
  gap: 1rem;
  margin-top: 1rem;
`;

const ModalDescription = styled.div`
  color: ${semanticColors.text.secondary};
  line-height: 1.6;
  text-align: center;
  margin: 0;
  font-size: 0.9rem;
`;

export default TempAuthModal;
